<!--财务报表-->
<template>
  <div style="height: 100%;background: white;">
    <div style="height: 100%;">
      <!--新的查询方式-->
      <div class="page_top_form">
        <el-form ref="form" label-width="90px">
          <el-form-item label="业主姓名">
            <el-input v-model="ownerName" placeholder="请输入业主名称" maxlength="20" style="width:140px"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期">
            <el-date-picker value-format="timestamp" size="small" v-model="datetimeValue" type="datetimerange"
              :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="mini" @click="getDataList">查询</el-button>
            <el-button type="primary" size="mini" @click="exportReport">报表导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="infoListContainer">
        <el-table :data="dataList" height="795" border style="width: 100%">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column prop="ownerName" label="业主姓名">
          </el-table-column>
          <el-table-column prop="time" label="结算周期">
          </el-table-column>
          <el-table-column prop="add" label="充值金额(元)">
            <template slot-scope="scope">
              <span>{{scope.row.add / 100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refund" label="退费金额(元)">
            <template slot-scope="scope">
              <span>{{scope.row.refund / 100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refund" label="账户余额(元)">
            <template slot-scope="scope">
              <span>{{scope.row.balance / 100}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <elPagination :total="totalSize" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
  import infoListMultipleSelection from '@/page/system/meterReading/infoListMultipleSelection.vue'
  import financeReportStore from './financeReportStore'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      infoListMultipleSelection,
      elPagination
    },
    props: {},
    data () {
      return {
        pageIndex: 1,
        pageSize: 20,
        totalSize: 0,
        dataList: [],
        deviceNos: '',
        ownerName: '',
        state: undefined,
        datetimeValue: [new Date(new Date().toLocaleDateString()).getTime()-3600*1000*24*32,new Date().getTime()],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '最近三个月',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*92);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
        loading: false,
      }
    },
    created () {},
    mounted () {
      this.getDataList()
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      columns () {
        return financeReportStore.state.columns
      },
      editOwnerName () {
        return userName => {
          return userName==null||userName==''||userName==undefined? '-':userName
        }
      },
      chargingStatusList () {
        return financeReportStore.state.chargingStatusList
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByDate()
        }
      },

    },
    watch: {
      nowUnit (nv,ov) {
        financeReportStore.commit('setNowUnit',nv)
        this.getDataList(nv)
      },
      pageIndex () {
        this.getDataList()
      }
    },
    methods: {
      //当前页
      pageindexChange (val) {
        this.pageIndex=val
        this.getDataList()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val
        this.pageIndex=1
        this.getDataList()
      },
      // 获取列表信息
      getDataList () {
        if(isempty(this.nowUnit)) {
          return
        }
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        if(this.datetimeValue[1]-this.datetimeValue[0]<31*24*60*60*1000) {
          this.$message({
            type: 'error',
            message: '查询时间周期不能小于一个月'
          })
          return
        }
        this.loading=true
        this.$api.meterReadingApi.getFinancialStatements(this.nowUnit.id,this.ownerName,this.datetimeValue[0],this.datetimeValue[1],this.pageIndex,this.pageSize,respon => {
          this.dataList=respon.dataList
          this.totalSize=respon.total
          this.loading=false
        },err => {
          this.$message.warning(err)
          this.loading=false
        })
      },
      // 导出报表
      exportReport () {
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        var title=this.nowUnit.name+'报表信息'
        this.$api.meterReadingApi.exportFinancialStatements(this.nowUnit.id,this.ownerName,this.datetimeValue[0],this.datetimeValue[1],respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .searchContainer {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  /deep/.el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    padding: 0 20px 0 20px;
    height: calc(100% - 76px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .infoListContainer>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>